import { FC } from 'react';
import { TextProps } from '../typography/model/TextProps';
import { Subtitle2 } from '../typography/TextStyles';

export const FormHeader1: FC<TextProps> = props => <Subtitle2 my={2} {...props} />;
